import { render, staticRenderFns } from "./YzTabs.vue?vue&type=template&id=673eeaf2&scoped=true&lang=pug&"
import script from "./YzTabs.vue?vue&type=script&lang=js&"
export * from "./YzTabs.vue?vue&type=script&lang=js&"
import style0 from "./YzTabs.vue?vue&type=style&index=0&id=673eeaf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673eeaf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabs})
